// POSITIONS
// culture
export const reitschulePositions = [
  {
    position: [46.9529304, 7.4403776],
    displayName: 'Reitschule',
    imgSrc: require('../images/reitschule.jpg')
  }
]

export const dampfzentralePositions = [
  {
    position: [46.9407529, 7.4441681],
    displayName: 'Dampfzentrale',
    imgSrc: require('../images/dampfzentrale.jpg')
  }
]

export const club111Positions = [
  {
    position: [46.9715732, 7.4503802],
    displayName: 'Theater Club 111',
    imgSrc: require('../images/club111.jpg')
  }
]

export const kunstkanalPositions = [
  {
    position: [46.9617237, 7.4480527],
    displayName: 'Kunstkanal',
    imgSrc: require('../images/kunstkanal.jpg')
  }
]

// economy
export const brasserieLorrainePositions = [
  {
    position: [46.9579986, 7.4457141],
    displayName: 'Brasserie Lorraine',
    imgSrc: require('../images/brasserie-lorraine.jpg')
  }
]

export const velokurierPositions = [
  {
    position: [46.9586655, 7.446029],
    displayName: 'Velokurier',
    imgSrc: require('../images/velokurier.jpg')
  }
]

export const manusPositions = [
  {
    position: [46.9469161, 7.4187329],
    displayName: 'Manus Bau + Schreinerei',
    imgSrc: require('../images/manus.jpg')
  }
]

export const velowerkstattPositions = [
  {
    position: [46.9585558, 7.4477763],
    displayName: 'Velowärchstatt',
    imgSrc: require('../images/velowerkstatt.jpg')
  }
]

export const hallerladenPositions = [
  {
    position: [46.9534296, 7.4324978],
    displayName: 'Hallerladen'
  }
]

export const wylereggladenPositions = [
  {
    position: [46.9600901, 7.4485229],
    displayName: 'Wyleregg-Lade',
    imgSrc: require('../images/wylereggladen.jpg')
  }
]

export const weltladenPositions = [
  {
    position: [46.9486267, 7.449351],
    displayName: 'Weltladen Bern'
  }
]

export const treuhandburoTisPositions = [
  {
    position: [46.9395976, 7.3944557],
    displayName: 'Treuhandbüro Tis'
  }
]

export const vorsorgestiftungGepabuPositions = [
  {
    position: [46.9476541, 7.4183897],
    displayName: 'Vorsorgestiftung Gepabu'
  }
]

// social
export const fixerstubliPositions = [
  {
    position: [46.9518682, 7.4424194],
    displayName: 'Fixerstübli',
    imgSrc: require('../images/fixerstubli.jpg')
  }
]

export const sleeperPositions = [
  {
    position: [46.9538261, 7.4387781],
    displayName: 'Sleeper',
    imgSrc: require('../images/sleeper.jpg')
  }
]

export const gassenarbeitPositions = [
  {
    position: [46.950714, 7.4418902],
    displayName: 'Kirchliche Gassenarbeit',
    imgSrc: require('../images/gassenarbeit.jpg')
  }
]

export const xeniaPositions = [
  {
    position: [46.949716, 7.457256],
    displayName: 'Xenia Bern'
  }
]

// housing
export const giebelPositions = [
  {
    position: [46.9587251, 7.4463509],
    displayName: 'Genossenschaft Giebel',
    imgSrc: require('../images/giebel.jpg')
  }
]

export const qHofPositions = [
  {
    position: [46.9584766, 7.4461078],
    displayName: 'Q-Hof',
    imgSrc: require('../images/q-hof.jpg')
  }
]

export const murifeldPositions = [
  {
    position: [46.941482, 7.470995],
    displayName: 'Murifeld-Quartier',
    imgSrc: require('../images/murifeld.jpg')
  }
]

export const zaffarayaPositions = [
  {
    position: [46.964105, 7.432486],
    displayName: 'Zaffaraya',
    imgSrc: require('../images/zaffaraya.jpg')
  }
]

export const viaFelsenauPositions = [
  {
    position: [46.9687582, 7.4415099],
    displayName: 'Via Felsenau',
    imgSrc: require('../images/felsenau.jpg')
  }
]

export const aarestrandPositions = [
  {
    position: [46.9567763, 7.4496941],
    displayName: 'WGB Aarestrand',
    imgSrc: require('../images/aarestrand.jpg')
  }
]

// hood
export const breitsTraffPositions = [
  {
    position: [46.9583499, 7.4547131],
    displayName: 'Breitsch-Träff',
    imgSrc: require('../images/breitsch-traff.jpg')
  }
]

export const villaStuckiPositions = [
  {
    position: [46.9393259, 7.4328015],
    displayName: 'Villa Stucki',
    imgSrc: require('../images/villa-stucki.jpg')
  }
]

export const labigiLorrainePositions = [
  {
    position: [46.9597313, 7.4435653],
    displayName: 'Läbigi Lorraine'
  }
]

// youth
export const bronxPositions = [
  {
    position: [46.9553281, 7.4298304],
    displayName: 'Jugendtreff Bronx',
    imgSrc: require('../images/bronx.jpg')
  }
]

export const jukoPositions = [
  {
    position: [46.948405, 7.440155],
    displayName: 'Juko Bern'
  }
]

export const spielewerkstattPositions = [
  {
    position: [46.9642685, 7.4552231],
    displayName: 'Berner Spielewerkstatt'
  }
]

export const schutzenwegPositions = [
  {
    position: [46.9592228, 7.4516521],
    displayName: 'Schützenweg-Spielplatz',
    imgSrc: require('../images/schutzenweg.jpg')
  }
]

export const graffitiPositions = [
  {
    position: [46.9649646, 7.4527409],
    displayName: 'Jugendzentrum Graffiti',
    imgSrc: require('../images/graffiti.jpg')
  }
]
